import { ethers } from "ethers";
import { op } from "../contracts/utils/utils";
import SaleFactoryArtifact from "../abi/SaleFactory.json";
import SaleArtifact from "../abi/Sale.json";
import ReserveTokenArtifact from "../abi/ReserveToken.json";
import { concat } from "ethers/lib/utils";
import { SALE_FACTORY_CONTRACT } from '../constants/constants';
export var Opcode;
(function (Opcode) {
    Opcode[Opcode["SKIP"] = 0] = "SKIP";
    Opcode[Opcode["VAL"] = 1] = "VAL";
    Opcode[Opcode["DUP"] = 2] = "DUP";
    Opcode[Opcode["ZIPMAP"] = 3] = "ZIPMAP";
    Opcode[Opcode["BLOCK_NUMBER"] = 4] = "BLOCK_NUMBER";
    Opcode[Opcode["BLOCK_TIMESTAMP"] = 5] = "BLOCK_TIMESTAMP";
    Opcode[Opcode["SENDER"] = 6] = "SENDER";
    Opcode[Opcode["IS_ZERO"] = 7] = "IS_ZERO";
    Opcode[Opcode["EAGER_IF"] = 8] = "EAGER_IF";
    Opcode[Opcode["EQUAL_TO"] = 9] = "EQUAL_TO";
    Opcode[Opcode["LESS_THAN"] = 10] = "LESS_THAN";
    Opcode[Opcode["GREATER_THAN"] = 11] = "GREATER_THAN";
    Opcode[Opcode["EVERY"] = 12] = "EVERY";
    Opcode[Opcode["ANY"] = 13] = "ANY";
    Opcode[Opcode["ADD"] = 14] = "ADD";
    Opcode[Opcode["SUB"] = 15] = "SUB";
    Opcode[Opcode["MUL"] = 16] = "MUL";
    Opcode[Opcode["DIV"] = 17] = "DIV";
    Opcode[Opcode["MOD"] = 18] = "MOD";
    Opcode[Opcode["POW"] = 19] = "POW";
    Opcode[Opcode["MIN"] = 20] = "MIN";
    Opcode[Opcode["MAX"] = 21] = "MAX";
    Opcode[Opcode["REPORT"] = 22] = "REPORT";
    Opcode[Opcode["NEVER"] = 23] = "NEVER";
    Opcode[Opcode["ALWAYS"] = 24] = "ALWAYS";
    Opcode[Opcode["SATURATING_DIFF"] = 25] = "SATURATING_DIFF";
    Opcode[Opcode["UPDATE_BLOCKS_FOR_TIER_RANGE"] = 26] = "UPDATE_BLOCKS_FOR_TIER_RANGE";
    Opcode[Opcode["SELECT_LTE"] = 27] = "SELECT_LTE";
    Opcode[Opcode["ERC20_BALANCE_OF"] = 28] = "ERC20_BALANCE_OF";
    Opcode[Opcode["ERC20_TOTAL_SUPPLY"] = 29] = "ERC20_TOTAL_SUPPLY";
    Opcode[Opcode["ERC721_BALANCE_OF"] = 30] = "ERC721_BALANCE_OF";
    Opcode[Opcode["ERC721_OWNER_OF"] = 31] = "ERC721_OWNER_OF";
    Opcode[Opcode["ERC1155_BALANCE_OF"] = 32] = "ERC1155_BALANCE_OF";
    Opcode[Opcode["ERC1155_BALANCE_OF_BATCH"] = 33] = "ERC1155_BALANCE_OF_BATCH";
    Opcode[Opcode["REMAINING_UNITS"] = 34] = "REMAINING_UNITS";
    Opcode[Opcode["TOTAL_RESERVE_IN"] = 35] = "TOTAL_RESERVE_IN";
    Opcode[Opcode["LAST_BUY_BLOCK"] = 36] = "LAST_BUY_BLOCK";
    Opcode[Opcode["LAST_BUY_UNITS"] = 37] = "LAST_BUY_UNITS";
    Opcode[Opcode["LAST_BUY_PRICE"] = 38] = "LAST_BUY_PRICE";
    Opcode[Opcode["CURRENT_BUY_UNITS"] = 39] = "CURRENT_BUY_UNITS";
    Opcode[Opcode["TOKEN_ADDRESS"] = 40] = "TOKEN_ADDRESS";
    Opcode[Opcode["RESERVE_ADDRESS"] = 41] = "RESERVE_ADDRESS";
})(Opcode || (Opcode = {}));
export const initSaleContracts = (saleData, signer) => {
    const sale = new ethers.Contract(saleData.id, SaleArtifact.abi, signer);
    const reserve = new ethers.Contract(saleData.reserve.id, ReserveTokenArtifact.abi, signer);
    const token = new ethers.Contract(saleData.token.id, ReserveTokenArtifact.abi, signer);
    return [sale, reserve, token];
};
export const saleDeploy = async (deployer, config, saleRedeemableERC20Config, ...args) => {
    const saleFactory = new ethers.Contract(SALE_FACTORY_CONTRACT, SaleFactoryArtifact.abi, deployer);
    const txDeploy = await saleFactory.createChildTyped(config, saleRedeemableERC20Config, ...args);
    return txDeploy.wait();
};
export const afterBlockNumberConfig = (blockNumber) => {
    return {
        sources: [
            concat([
                // (BLOCK_NUMBER blockNumberSub1 gt)
                op(Opcode.BLOCK_NUMBER),
                op(Opcode.VAL, 0),
                op(Opcode.GREATER_THAN),
            ]),
        ],
        constants: [blockNumber - 1],
        stackLength: 3,
        argumentsLength: 0,
    };
};
export const afterTimestampConfig = (timestamp) => {
    return {
        sources: [
            concat([
                // (BLOCK_NUMBER blockNumberSub1 gt)
                op(Opcode.BLOCK_TIMESTAMP),
                op(Opcode.VAL, 0),
                op(Opcode.GREATER_THAN),
            ]),
        ],
        constants: [timestamp],
        stackLength: 3,
        argumentsLength: 0,
    };
};
export const getAfterTimestampDate = (stateConfig) => {
    if (stateConfig.sources[0] === "0x050001000b00") {
        return new Date(parseInt(stateConfig.constants[0]) * 1000);
    }
};
export const getAfterTimestamp = (stateConfig) => {
    if (stateConfig.sources[0] === "0x050001000b00") {
        return parseInt(stateConfig.constants[0]);
    }
};
export const saleStatuses = ["Pending", "Active", "Success", "Fail"];
